import { EPhoneActionTypes } from '../../actions/phone';
import { EStatus } from '../../types/auth';
import { TReduxActions } from '../../types/redux';

const defaultState: { uuid: string; phoneNumber: string; fetchPhoneStatus: EStatus; fetchPhoneError: string } = {
  uuid: '',
  phoneNumber: '',
  fetchPhoneStatus: EStatus.IDLE,
  fetchPhoneError: '',
};

export function phoneReducer(
  state: { uuid: string; phoneNumber: string; fetchPhoneStatus: EStatus; fetchPhoneError: string } = defaultState,
  action: TReduxActions,
) {
  switch (action.type) {
    case EPhoneActionTypes.ChangePhone:
      return {
        ...state,
        phoneNumber: action.payload,
      };

    case EPhoneActionTypes.ConfirmPhoneRequest:
      return {
        ...state,
        fetchPhoneStatus: EStatus.LOADING,
      };

    case EPhoneActionTypes.ConfirmPhoneSuccess:
      return {
        ...state,
        uuid: action.payload,
        fetchPhoneStatus: EStatus.SUCCESS,
      };

    case EPhoneActionTypes.ConfirmPhoneError:
      return {
        ...state,
        fetchPhoneStatus: action.payload ? EStatus.ERROR : EStatus.IDLE,
        fetchPhoneError: action.payload,
      };

    default:
      return state;
  }
}
